// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"866":"fda8e0df","939":"4625ad4a"}[chunkId] + ".chunk.css";
};